import(/* webpackMode: "eager" */ "/src/app/privacy/page.tsx");
